// =============================================================================
// Abmelden nach Inaktivität (reine Logik)
// =============================================================================
// Nach 5 Minuten ohne Nutzung (Maus, Tastatur, Scrollen, Touch) wird
// abgemeldet; 1 Minute vorher erscheint eine Warnung. Die letzte Aktivität
// liegt in localStorage, damit alle Tabs dieselbe Zeit sehen und ein nach
// längerer Pause wieder geöffneter Browser sofort abmeldet.
// Die Höchstdauer einer Sitzung (12 Stunden) setzt zusätzlich der Server durch.
// =============================================================================

export const LEERLAUF_MS = 5 * 60_000;
export const WARNUNG_MS = 4 * 60_000;
export const SCHLUESSEL_AKTIVITAET = 'crm.letzteAktivitaet';
export const SCHLUESSEL_ABMELDUNG = 'crm.abmeldung';
export const SCHLUESSEL_GRUND = 'crm.abmeldeGrund';

export type Zustand = 'aktiv' | 'warnung' | 'abmelden';

export function zustandBei(letzteAktivitaet: number, jetzt: number): Zustand {
  const pause = jetzt - letzteAktivitaet;
  if (pause >= LEERLAUF_MS) return 'abmelden';
  if (pause >= WARNUNG_MS) return 'warnung';
  return 'aktiv';
}

export function restSekunden(letzteAktivitaet: number, jetzt: number): number {
  return Math.max(0, Math.ceil((letzteAktivitaet + LEERLAUF_MS - jetzt) / 1000));
}

export function leseZeit(roh: string | null): number | null {
  const n = roh === null ? NaN : Number(roh);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/** localStorage kann fehlen oder werfen (privater Modus) – dann nur im Speicher. */
export function speicherLesen(schluessel: string): string | null {
  try { return window.localStorage.getItem(schluessel); } catch { return null; }
}

export function speicherSchreiben(schluessel: string, wert: string): void {
  try { window.localStorage.setItem(schluessel, wert); } catch { /* ohne Speicher nur dieser Tab */ }
}
